$(function(){
    updateSwiper();
})

$(window).resize(function(){
    updateSwiper();
})

function updateSwiper(){

    $(".custom-list-swiper").each(function(){
      if($(window).width() < 750){
        $(this).attr("slides-per-view", $(this).attr("data-mob"));
      }
      else{
        $(this).attr("slides-per-view", $(this).attr("data-desk"));
      }
    })
    if($(window).width() < 990){
        $(".custom-feed-swiper").attr("slides-per-view", 3);
    }
    else{
        $(".custom-feed-swiper").attr("slides-per-view", 6);
    }

    if($(window).width() < 750){
      $(".custom-logos-slider-swiper").attr("slides-per-view", 3);
      
      $(".custom-card-swiper").attr("slides-per-view", 1.2);
      $(".custom-card-swiper").attr("loop", "true");
      $(".custom-card-swiper").attr("centered-slides", "true");

      $(".custom-testimonial-2-swiper").attr("slides-per-view", 1.1);
      $(".custom-testimonial-2-swiper").attr("space-between", 10);

      $(".custom-main-product-media-thumb-swiper").attr("slides-per-view", 5);
      if($(".custom-main-product-media-swiper").hasClass("custom-main-product--show-dots")){
        $(".custom-main-product-media-swiper").attr("pagination", "true");
        $(".custom-main-product-media-swiper").attr("pagination-clickable", "true");
      }
    }
    else{
      $(".custom-logos-slider-swiper").attr("slides-per-view", 4);

      $(".custom-card-swiper").attr("slides-per-view", 3);
      $(".custom-card-swiper").removeAttr("loop");
      $(".custom-card-swiper").removeAttr("centered-slides");

      $(".custom-testimonial-2-swiper").attr("slides-per-view", 3);
      $(".custom-testimonial-2-swiper").attr("space-between", 40);

      $(".custom-main-product-media-thumb-swiper").attr("slides-per-view", 7.5);
      if($(".custom-main-product-media-swiper").hasClass("custom-main-product--show-dots")){
        $(".custom-main-product-media-swiper").removeAttr("pagination", "true");
        $(".custom-main-product-media-swiper").removeAttr("pagination-clickable", "true");
      }
    }

    if($(window).width() <= 550){
        $(".custom-reviews-swiper").attr("slides-per-view", 1);
        console.log("1280")
    }
    else if($(window).width() <= 749){
        $(".custom-reviews-swiper").attr("slides-per-view", 2);
        console.log("1024")
    }
    else if($(window).width() <= 989){
        $(".custom-reviews-swiper").attr("slides-per-view", 1);
        console.log("989")
    }
    else if($(window).width() <= 1024){
        $(".custom-reviews-swiper").attr("slides-per-view", 2);
        console.log("749")
    }
    else if($(window).width() <= 1280){
        $(".custom-reviews-swiper").attr("slides-per-view", 3);
        console.log("550")
    }
    else{
        $(".custom-reviews-swiper").attr("slides-per-view", 4);
        console.log("else")
    }
}

$(".custom-banner-video-button").click(function(){
  if(!$(this).hasClass("active")){
    $(this).addClass("active");
    $(this).parent().find(".custom-banner-video").trigger("pause");
  }
  else{
    $(this).removeClass("active");
    $(this).parent().find(".custom-banner-video").trigger("play");
  }
})

$(".custom-menu-title").click(function(){
  $(this).toggleClass("active");
  $(this).next(".custom-menu-item-list").slideToggle(300);
})

$(".new-coll-header-item").click(function(){
  let id = $(this).attr("data-id");
  $(this).parent().find(".new-coll-header-item").removeClass("active");
  $(this).parents(".new-coll").find(".new-coll-wrapper").removeClass("active");
  $(this).parents(".new-coll").find(`.new-coll-wrapper[data-id="${id}"]`).addClass("active");
  $(this).addClass("active");
})

$(".custom-faq-block-title").click(function(){
    if($(this).parent().hasClass("active")){
        $(this).parent().toggleClass("active");
        $(this).next(".custom-faq-block-content").slideToggle(250);
    }
    else{
        $(this).parents(".custom-faq-block-wrapper").find(".custom-faq-block").removeClass("active");
        $(this).parents(".custom-faq-block-wrapper").find(".custom-faq-block-content").slideUp(250);
        $(this).parent().addClass("active");
        $(this).next(".custom-faq-block-content").slideDown(250);
    }
})

$(".custom-acc-title-wrapper").click(function(){
  if($(this).hasClass("active")){
      $(this).toggleClass("active");
      $(this).next(".custom-acc-content").slideToggle(250);
  }
  else{
      $(this).parents(".custom-acc-wrapper").find(".custom-acc-title-wrapper").removeClass("active");
      $(this).parents(".custom-acc-wrapper").find(".custom-acc-content").slideUp(250);
      $(this).addClass("active");
      $(this).next(".custom-acc-content").slideDown(250);
  }
})

$(".footer-block__heading").click(function(){
    if($(this).hasClass("active")){
        $(this).toggleClass("active");
        $(this).next(".footer-block__details-content").slideToggle(250);
    }
    else{
        $(this).parents(".footer__blocks-wrapper").find(".footer-block__heading").removeClass("active");
        $(this).parents(".footer__blocks-wrapper").find(".footer-block__details-content").slideUp(250);
        $(this).addClass("active");
        $(this).next(".footer-block__details-content").slideDown(250);
    }
});

$(document).on("click", ".custom-cart-upsell-atc", function(){
    let arr = [];
    arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
    AddUpsellToCart(arr, $(this));
})

$(".custom-hotspots-item").click(function(){
  $(this).parent().find(".custom-hotspots-item").removeClass("active");
  $(this).addClass("active");
  $(this).parents(".custom-hotspots").find(".custom-hotspots-mobile-text").text($(this).find(".custom-hotspots-text").text());
})

$(document).on("click", ".custom-addon-atc", function(){
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  AddUpsellToCart(arr, $(this), true);
})

function AddUpsellToCart(productsArr, $this, open=false){
    $this.addClass("active");
    let formData = {
      'items': productsArr,
      sections: "cart-drawer,cart-icon-bubble"
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(res => {
      if(res.status){
        console.log(res);
      }
      else{
        const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
        const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
        $("cart-drawer.drawer").removeClass("is-empty");
        $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
        $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
        if(open){
          document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
          $(".cart-count-bubble").trigger("click");
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      $this.removeClass("active");
    });
  }

  $(document).on("click", ".custom-header-drawer-close", function(){
    $(".header__icon--menu").trigger("click");
  })
  
  Fancybox.bind("[data-fancybox]", {});

  $(".custom-main-product-swatch").hover(function(){
    $(".custom-product-swatch-heading span").text($(this).attr("data-title"));
  }, function(){
    $(".custom-product-swatch-heading span").text($(this).attr("data-d-title"));
  })

  $(".new-faq-block-title").click(function(){
    if($(this).parent().hasClass("active")){
        $(this).parent().toggleClass("active");
        $(this).next(".new-faq-block-content").fadeToggle(200);
    }
    else{
        $(this).parents(".new-faq-block-wrapper").find(".new-faq-block").removeClass("active");
        $(this).parents(".new-faq-block-wrapper").find(".new-faq-block-content").hide();
        $(this).parent().addClass("active");
        $(this).next(".new-faq-block-content").fadeIn(200);
    }
  })

  $(".new-faq-cat-list-item").click(function(){
    $(".new-faq-block-wrapper").removeClass("active");
    $(`.new-faq-block-wrapper[data-title=${$(this).attr("data-title")}]`).addClass("active");
    $(this).parent().find(".new-faq-cat-list-item").removeClass("active");
    $(this).addClass("active");
  })

  $(".new-cwl-item-thumb").click(function(e){
    e.preventDefault();
    e.stopPropagation();
    $(this).parents(".new-cwl-item-img-wrapper").find(".new-cwl-item-img").attr("src", $(this).attr("data-img"));
  });

  $(".custom-mp-details-link").click(function(){
    if($(".custom-mp-details").length > 0){
      let top = $(".custom-mp-details").offset().top;
      $('html,body').animate({scrollTop: top}, 300);
    }
  })

  $(".new-stabs-li").click(function(){
    $(this).parent().find(".new-stabs-li").removeClass("active");
    $(this).addClass("active");
    let title = $(this).attr("data-title");
    $(this).parents(".new-stabs-tab-wrapper").find(`.new-stabs-tab`).removeClass("active");
    $(this).parents(".new-stabs-tab-wrapper").find(`.new-stabs-tab[data-title="${title}"]`).addClass("active")
  })